import {
  SURVEY_QUESTION_ONE,
  SURVEY_QUESTION_TWO,
  SURVEY_QUESTION_THREE,
} from '../../shared/Surveys/MultipleChoiceSurvey';

export { default } from './MonthlyGoalBanner';

export { default as MonthlyGoalSurvey, MONTHLY_GOAL_SURVEY_KEY } from './MonthlyGoalSurvey';

export const MONTHLY_GOAL_EXPIRY_DAYS = 30;
export const MONTHLY_GOAL_REMINDER_DAYS = 15;
export const MONTHLY_GOAL_REMINDER_DISMISSED_KEY = 'proMonthlyGoalReminderDismissed';

export const getGoalText = goal => {
  let goalText;
  let innerText;

  switch (Number.parseInt(Object.keys(goal.goal)[0], 10)) {
    case SURVEY_QUESTION_ONE:

      switch (goal.goal[SURVEY_QUESTION_ONE]) {
        case 1:
          innerText = '2';
          break;
        case 2:
          innerText = '4';
          break;
        case 3:
          innerText = '6+';
          break;
        default:
          break;
      }

      goalText = `Attract ${innerText} New Clients`;
      break;
    case SURVEY_QUESTION_TWO:

      switch (goal.goal[SURVEY_QUESTION_TWO]) {
        case 1:
          innerText = '$75';
          break;
        case 2:
          innerText = '$150';
          break;
        case 3:
          innerText = '$250';
          break;
        default:
          break;
      }

      goalText = `Increase monthly revenue by ${innerText} or more`;
      break;
    case SURVEY_QUESTION_THREE:
      switch (goal.goal[SURVEY_QUESTION_THREE]) {
        case 1:
          goalText = 'Be an expert on StyleSeat features';
          break;
        case 2:
          goalText = 'Transition my clients to StyleSeat';
          break;
        case 3:
          goalText = 'Polish my service menu + pricing';
          break;
        default:
          break;
      }
      break;
    default:
      break;
  }

  return goalText;
};
